import { createContext } from 'react';

import type { Identity } from './session';

export type AuthStatus = 'restoring' | 'anonymous' | 'authenticated';

export interface AuthContextValue {
  status: AuthStatus;
  identity: Identity | null;
  /** Send a pin; resolves to the challenge id the pin answers. */
  requestPin: (email: string) => Promise<string>;
  /** Exchange a pin for a session. `beforeSignIn` runs with the new token
   *  before the app sees the identity; the session is adopted either way. */
  submitPin: (
    challengeId: string,
    pin: string,
    beforeSignIn?: (token: string) => Promise<void>,
  ) => Promise<void>;
  signOut: () => Promise<void>;
}

/** Its own module so `AuthProvider.tsx` exports components only — a file that
 *  mixes the two loses fast refresh for everything in it. */
export const AuthContext = createContext<AuthContextValue | null>(null);
